/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S7_Li1_DescInputs */

const tr_iade_iptal_s7_li1_desc = /** @type {(inputs: Iade_Iptal_S7_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Süre bitiminden 7 (yedi) gün ve 1 (bir) gün önce Abone'ye kayıtlı e-posta adresinden, bitiş tarihini ve yenileme bağlantısını içeren hatırlatma yapılır.`)
};

const en_iade_iptal_s7_li1_desc = /** @type {(inputs: Iade_Iptal_S7_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 (seven) days and 1 (one) day before the end of the term a reminder with the end date and the renewal link is sent to the Subscriber's registered email address.`)
};

const de_iade_iptal_s7_li1_desc = /** @type {(inputs: Iade_Iptal_S7_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7 (sieben) Tage und 1 (einen) Tag vor dem Ende erhält der Abonnent an die hinterlegte E-Mail-Adresse eine Erinnerung mit Enddatum und Verlängerungs-Link.`)
};

const ru_iade_iptal_s7_li1_desc = /** @type {(inputs: Iade_Iptal_S7_Li1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За 7 (семь) дней и за 1 (один) день до окончания срока Абоненту на зарегистрированный адрес электронной почты направляется напоминание с датой окончания и ссылкой на продление.`)
};

/**
* | output |
* | --- |
* | "7 (seven) days and 1 (one) day before the end of the term a reminder with the end date and the renewal link is sent to the Subscriber's registered email addr..." |
*
* @param {Iade_Iptal_S7_Li1_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s7_li1_desc = /** @type {((inputs?: Iade_Iptal_S7_Li1_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S7_Li1_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s7_li1_desc(inputs)
	if (locale === "de") return de_iade_iptal_s7_li1_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s7_li1_desc(inputs)
	return tr_iade_iptal_s7_li1_desc(inputs)
});